export default value => {
  if (!value || !value?.trim()?.length) {
    return '';
  }

  return value[0].toUpperCase() + value.substring(1);
};
